import { render, staticRenderFns } from "./ResourcesCenter.vue?vue&type=template&id=9584c49e&scoped=true"
import script from "./ResourcesCenter.vue?vue&type=script&lang=js"
export * from "./ResourcesCenter.vue?vue&type=script&lang=js"
import style0 from "./ResourcesCenter.vue?vue&type=style&index=0&id=9584c49e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9584c49e",
  null
  
)

export default component.exports